import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { FormBuilderValues } from './FormBuilder';
import { useFormBuilderDialogContext } from './FormBuilderDialogContext';
import { FormListItemContextProvider } from './FormListItemContext';
import { FormItemList } from './FormItemList';
import { HeadingFormItemDialog } from './dialogs/HeadingFormItemDialog';
import { ContentFormItemDialog } from './dialogs/ContentFormItemDialog';
import { FieldFormItemDialog } from './dialogs/FieldFormItemDialog';
import { MediaFormItemDialog } from './dialogs/MediaFormItemDialog';
import { RepeatableGroupFormItemDialog } from './dialogs/RepeatableGroupFormItemDialog';
import { PageBreakFormItemDialog } from './dialogs/PageBreakFormItemDialog';

export function FormListItemsForm() {
  const { values, setFieldValue } = useFormikContext<FormBuilderValues>();

  const {
    openHeadingDialogState,
    closeHeadingDialog,
    openContentDialogState,
    closeContentDialog,
    openFieldDialogState,
    closeFieldDialog,
    openMediaDialogState,
    closeMediaDialog,
    openRepeatableGroupDialogState,
    closeRepeatableGroupDialog,
    openPageBreakDialogState,
    closePageBreakDialog,
  } = useFormBuilderDialogContext();

  return (
    <FieldArray name='formItems'>
      {(arrayHelpers) => (
        <>
          <FormListItemContextProvider formItems={values.formItems} setFieldValue={setFieldValue}>
            <FormItemList />
          </FormListItemContextProvider>
          <HeadingFormItemDialog
            open={openHeadingDialogState.open}
            close={closeHeadingDialog}
            arrayHelpers={arrayHelpers}
            data={openHeadingDialogState.data}
          />
          <ContentFormItemDialog
            open={openContentDialogState.open}
            close={closeContentDialog}
            arrayHelpers={arrayHelpers}
            data={openContentDialogState.data}
          />
          <FieldFormItemDialog
            open={openFieldDialogState.open}
            close={closeFieldDialog}
            arrayHelpers={arrayHelpers}
            data={openFieldDialogState.data}
            targetGroupId={openFieldDialogState.targetGroupId}
          />
          <MediaFormItemDialog
            open={openMediaDialogState.open}
            close={closeMediaDialog}
            arrayHelpers={arrayHelpers}
            data={openMediaDialogState.data}
          />
          <RepeatableGroupFormItemDialog
            open={openRepeatableGroupDialogState.open}
            close={closeRepeatableGroupDialog}
            arrayHelpers={arrayHelpers}
            data={openRepeatableGroupDialogState.data}
          />
          <PageBreakFormItemDialog
            open={openPageBreakDialogState.open}
            close={closePageBreakDialog}
            data={openPageBreakDialogState.data}
          />
        </>
      )}
    </FieldArray>
  );
}
